$(document).ready(function(){
        $('.play_pause .btn').click(function () {
            console.log("clicke don play pause")
            var mediaVideo = $(this).closest(".banner__media").find(".video-homepage").get(0);
            if ($(this).hasClass('pause')) {
                mediaVideo.pause();
                $(this).closest(".banner__media").find('.buttons_play_pause .pause').hide();
                $(this).closest(".banner__media").find('.buttons_play_pause .play').show();
                mediaVideo.removeAttribute('controls');
            }else{
                mediaVideo.play();
                $(this).closest(".banner__media").find('.buttons_play_pause .play').hide();
                $(this).closest(".banner__media").find('.buttons_play_pause .pause').show();
                mediaVideo.removeAttribute('controls');
            }
        });


        $('.buttons_mute_sound .btn').click(function () {
                if ($(this).hasClass('mute')) {
                    $(this).closest(".banner__media").find(".video-homepage").prop('muted', true);
                    $(this).closest(".banner__media").find('.buttons_play_pause .mute').hide();
                    $(this).closest(".banner__media").find('.buttons_play_pause .unmute').show();
                }else{
                        $(this).closest(".banner__media").find(".video-homepage").prop('muted', false);
                        $(this).closest(".banner__media").find('.buttons_play_pause .unmute').hide();
                        $(this).closest(".banner__media").find('.buttons_play_pause .mute').show();
                } 
        });
});